import { render, staticRenderFns } from "./WalletListView.vue?vue&type=template&id=1171b063&scoped=true"
import script from "./WalletListView.vue?vue&type=script&lang=js"
export * from "./WalletListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171b063",
  null
  
)

export default component.exports